import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseRestService } from '../common/BaseRestService';

@Injectable()
export class ReportsRestService extends BaseRestService {

    constructor(private http: HttpClient) {
        super('directory');
    }

    getTotalUserCount(): Observable<any> {
        return this.http.get(this.getEndpoint(['idm', 'report', 'users', 'total']));
    }

    getFilteredCount(exportParams: FormData): Observable<any> {
        return this.http.post(this.getEndpoint(['idm', 'report', 'users', 'filtered']), exportParams);
    }

    exportByCountry(exportParams: FormData): Observable<any> {
        return this.http.post(this.getEndpoint(['idm', 'report', 'users', 'export', 'country']), exportParams, {
            responseType: 'blob',
            observe: 'response',
        });
    }

    exportByRegion(exportParams: FormData): Observable<any> {
        return this.http.post(this.getEndpoint(['idm', 'report', 'users', 'export', 'region']), exportParams, {
            responseType: 'blob',
            observe: 'response',
        });
    }

    searchUsers(exportParams: FormData): Observable<any> {
        return this.http.post(this.getEndpoint(['idm', 'report', 'user-role']), exportParams);
    }

    exportResult(exportParams: FormData): Observable<any> {
        return this.http.post(this.getEndpoint(['idm', 'report', 'user-role', 'export']), exportParams, {
            responseType: 'blob',
            observe: 'response',
        });
    }

}
